<template>
  <div class="table-graph-wrap">
    <div class="big-graph" :class="{ star: star }">
      <div class="big-graph-bar">
        <div
          class="big-graph-bar-fill"
          :class="
            `big-graph-bar-fill--${color} big-graph-persentage--${labelPosition}`
          "
          :style="`width: ${value * 100}%;`"
        >
          <div class="big-graph-persentage" v-if="mark">
            {{ value | percentage }}
          </div>
        </div>
        <div
          class="big-graph-devider"
          v-if="mark"
          :style="`left: ${mark * 100}%`"
        ></div>
      </div>
      <div class="big-graph-desc" v-if="price || price === 0 || percent || percent === 0">
        <div class="price" v-if="number || number === 0">{{ number }}</div>
        <div class="price" v-if="price || price === 0 ">{{ price | currency({ fractionCount: 0 }) }}</div>
        <div class="price" v-if="percent || percent === 0">{{ percent | numeral('0%') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoeHorizontalBar",
  props: {
    value: {
      required: true
    },
    color: {
      type: String,
      required: true
    },
    mark: {
      type: Number,
      required: false
    },
    price: {
      type: Number,
      required: false
    },
    percent: {
      type: Number,
      required: false
    },
    number: {
      type: Number,
      required: false
    },
    star: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    }
  },
  computed: {
    labelPosition() {
      if (this.value <= 0.2) return "left";
      return this.star && this.value >= 0.9 ? "right" : "";
    }
  }
};
</script>
